var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.scatterChartData)?_c('v-chart',{ref:"scatterChart",staticClass:"scatter-chart",attrs:{"init-options":_vm.initOptions,"option":_vm.options,"autoresize":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }